export function applyFill(ctx, fill, x, y, width, height) {
    if (!fill) {
        return;
    }
    if (typeof fill === 'object' && 'type' in fill && 'stops' in fill) {
        const gradient = fill;
        let canvasGradient;
        if (gradient.type === 'linear') {
            const angle = (gradient.angle || 0) * Math.PI / 180;
            const centerX = x + width / 2;
            const centerY = y + height / 2;
            const length = Math.max(width, height);
            const x0 = centerX - Math.cos(angle) * length / 2;
            const y0 = centerY - Math.sin(angle) * length / 2;
            const x1 = centerX + Math.cos(angle) * length / 2;
            const y1 = centerY + Math.sin(angle) * length / 2;
            canvasGradient = ctx.createLinearGradient(x0, y0, x1, y1);
        }
        else {
            const focusX = gradient.focusX !== undefined ? gradient.focusX : 0.5;
            const focusY = gradient.focusY !== undefined ? gradient.focusY : 0.5;
            const centerX = x + width * focusX;
            const centerY = y + height * focusY;
            const radius = Math.max(Math.sqrt(Math.pow(x - centerX, 2) + Math.pow(y - centerY, 2)), Math.sqrt(Math.pow(x + width - centerX, 2) + Math.pow(y - centerY, 2)), Math.sqrt(Math.pow(x - centerX, 2) + Math.pow(y + height - centerY, 2)), Math.sqrt(Math.pow(x + width - centerX, 2) + Math.pow(y + height - centerY, 2)));
            canvasGradient = ctx.createRadialGradient(centerX, centerY, 0, centerX, centerY, radius);
        }
        for (const stop of gradient.stops) {
            const color = stop.alpha !== undefined
                ? hexToRgba(stop.color, stop.alpha)
                : stop.color;
            canvasGradient.addColorStop(stop.position, color);
        }
        ctx.fillStyle = canvasGradient;
        return;
    }
    if (typeof fill === 'string') {
        ctx.fillStyle = fill;
        return;
    }
    if (typeof fill === 'object' && 'r' in fill && 'g' in fill && 'b' in fill) {
        const color = fill;
        const a = color.a !== undefined ? color.a : 1;
        ctx.fillStyle = `rgba(${color.r}, ${color.g}, ${color.b}, ${a})`;
        return;
    }
}
function hexToRgba(hex, alpha) {
    const r = parseInt(hex.slice(1, 3), 16);
    const g = parseInt(hex.slice(3, 5), 16);
    const b = parseInt(hex.slice(5, 7), 16);
    return `rgba(${r}, ${g}, ${b}, ${alpha})`;
}
//# sourceMappingURL=gradient.js.map